import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { CreativesetDataService } from '@app/shared/creativeset';
import { CampaignService } from '@app/shared/services';
import { UIDropdownComponent } from '@bannerflow/ui';
import { ICampaignPublishInfo } from '@studio/domain/campaign';
import { ICreative } from '@studio/domain/creativeset/creative/creative';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TileSelectService } from '../services';

@Component({
    selector: 'add-to-campaign-dropdown',
    templateUrl: './add-to-campaign-dropdown.component.html',
    styleUrls: ['./add-to-campaign-dropdown.component.scss']
})
export class AddToCampaignDropdownComponent implements OnInit, OnDestroy {
    @Output() disabled = new EventEmitter<boolean>();
    @Output() title = new EventEmitter<string>();

    @ViewChild('dropdown', { static: true }) dropdown: UIDropdownComponent;

    addToCampaignOptions: ICampaignPublishInfo[];

    private creatives: ICreative[];
    private unsubscribe$ = new Subject<void>();

    constructor(
        private creativesetDataService: CreativesetDataService,
        private tileSelectService: TileSelectService,
        private campaignService: CampaignService
    ) {}

    ngOnInit(): void {
        this.tileSelectService.selection$.pipe(takeUntil(this.unsubscribe$)).subscribe(creatives => {
            this.creatives = creatives.filter(c => c.design);
            this.setAddToCampaignState();
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    private setAddToCampaignState(): void {
        this.addToCampaignOptions = this.creatives.length ? this.campaignService.getCampaigns() : [];

        const disabled = !this.addToCampaignOptions.length;
        this.disabled.emit(disabled);

        const lengthString = disabled ? '' : `(${this.creatives.length})`;
        this.title.emit(`Add to campaign ${lengthString}`);
    }

    addTo(campaign: ICampaignPublishInfo): void {
        const creativeSetId = this.creativesetDataService.creativeset.id;
        const creativesIds = this.creatives.map(({ id }) => id);

        this.campaignService.addToCampaign(campaign.id, creativesIds, creativeSetId);
    }
}
